import { render, staticRenderFns } from "./BreakManagementOverview.vue?vue&type=template&id=15ad4743&scoped=true&"
import script from "./BreakManagementOverview.vue?vue&type=script&lang=js&"
export * from "./BreakManagementOverview.vue?vue&type=script&lang=js&"
import style0 from "./BreakManagementOverview.vue?vue&type=style&index=0&id=15ad4743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad4743",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ad4743')) {
      api.createRecord('15ad4743', component.options)
    } else {
      api.reload('15ad4743', component.options)
    }
    module.hot.accept("./BreakManagementOverview.vue?vue&type=template&id=15ad4743&scoped=true&", function () {
      api.rerender('15ad4743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BreakManagement/BreakManagementOverview.vue"
export default component.exports